/**
 * Eager, one-time initialization of side-effect library plugins.
 *
 * Why this file exists:
 * Plugins like `leaflet.markercluster` augment a base library (Leaflet's `L`) as an
 * import side-effect. Under the webpack builder these augmentations were hoisted early
 * enough that consumers always saw the patched library. Under the esbuild builder the
 * eval order of lazy chunks is not guaranteed, so a map directive's ngOnInit could call
 * `L.markerClusterGroup(...)` BEFORE the plugin attached it — an intermittent
 * "Z.markerClusterGroup is not a function" crash (which also cascaded into reactive-form
 * `_rawValidators` errors when it threw mid change-detection).
 *
 * Importing the plugin here, before AppModule/bootstrap, makes the patch deterministic:
 * the base library is augmented once, up front, so every consumer (eager or lazy) sees it.
 *
 * Keep this list to plugins that (a) augment a shared base lib by side-effect AND
 * (b) are reached on a hot/early path. Do NOT add heavy on-demand plugins (e.g.
 * jspdf-autotable) here — that would pull their large base lib into the initial bundle.
 */

import * as L from 'leaflet';
import 'leaflet.markercluster';

// Touch shim for the native HTML5 drag-and-drop used by the schedule employee card.
// HTML5 DnD only fires for mouse input, so without this tablets lose shift dragging. The library
// self-installs a singleton on import and translates touch gestures into drag/drop events.
import 'drag-drop-touch';

// Some Leaflet plugins/consumers read a global `L`. Expose it without clobbering an
// existing global.
(window as any).L = (window as any).L || L;
